var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.init
        ? _c(
            "div",
            [
              _c(
                "div",
                { staticClass: "header-actions" },
                [
                  _c("CorpId"),
                  _vm._v(" "),
                  _c("CompassButton", {
                    staticClass: "ml-3",
                    attrs: {
                      label: _vm.$t.__("developerPage.ApiV2.create_api_access"),
                      disabled: _vm.clients.length >= _vm.maxTokens
                    },
                    on: {
                      click: function($event) {
                        return _vm.showCreateClientForm()
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.formatedClients,
                    "default-sort": { prop: "name", order: "ascending" },
                    border: ""
                  }
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t.__("common.labels.name"),
                      prop: "name",
                      sortable: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t.__("common.labels.type"),
                      prop: "type"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.type === "personal_access_token"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$l10n.__("Token personnel"))
                                    )
                                  ])
                                : scope.row.type === "personal"
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$l10n.__("Personnel")))
                                  ])
                                : scope.row.type === "private"
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$l10n.__("Privé")))
                                  ])
                                : scope.row.type === "public"
                                ? _c("span", [
                                    _vm._v(_vm._s(_vm.$l10n.__("Publique")))
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.type === "public" &&
                              !scope.row.validated_at
                                ? _c("span", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(
                                          _vm.$l10n.__(
                                            "En attente de validation"
                                          )
                                        ) +
                                        ")"
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.type === "personal" &&
                              scope.row.delegated
                                ? _c("span", [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.$l10n.__("Accès délégué")) +
                                        ")"
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      550463332
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t.__("developerPage.ApiV2.scopes"),
                      prop: "scopes"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return _vm._l(scope.row.scopes, function(item) {
                              return _c(
                                "CompassTag",
                                {
                                  key: item,
                                  staticClass: "api-scope",
                                  attrs: { color: "stroked" }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(item) +
                                      "\n                    "
                                  )
                                ]
                              )
                            })
                          }
                        }
                      ],
                      null,
                      false,
                      370951053
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: _vm.$t.__("common.labels.staff"),
                      prop: "user",
                      sortable: ""
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              scope.row.user && scope.row.user.staffid
                                ? _c("person-list", {
                                    attrs: { list: [scope.row.user] }
                                  })
                                : scope.row.user &&
                                  scope.row.user.type === "staff"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$l10n.__("Collaborateur")) +
                                        " " +
                                        _vm._s(scope.row.user.id)
                                    )
                                  ])
                                : scope.row.user
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$l10n.__("Contact")) +
                                        " " +
                                        _vm._s(scope.row.user.id)
                                    )
                                  ])
                                : _vm._e()
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      3580615109
                    )
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      label: "",
                      width: "40",
                      "class-name": "el-table-column--contextmenu"
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "CompassMenu",
                                {
                                  attrs: {
                                    trigger: "click",
                                    "custom-class": "api-context-menu",
                                    placement: "left-start"
                                  }
                                },
                                [
                                  _c("CompassIcon", {
                                    attrs: {
                                      role: "button",
                                      type: "link",
                                      size: "medium",
                                      icon: "action"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "template",
                                    { slot: "dropdown" },
                                    [
                                      _c("CompassMenuItem", {
                                        key:
                                          "contextmenu" +
                                          scope.row.id +
                                          "_edit",
                                        attrs: {
                                          disabled:
                                            scope.row.type ===
                                            "personal_access_token",
                                          label: _vm.$t.__(
                                            "developerPage.ApiV2.edit_token"
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.editClient(scope.row)
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("CompassMenuItem", {
                                        key:
                                          "contextmenu" +
                                          scope.row.id +
                                          "_removed",
                                        attrs: {
                                          label: _vm.$t.__(
                                            "developerPage.ApiV2.delete_token"
                                          )
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeClient(
                                              scope.row.id,
                                              scope.row.name
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                2
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2571049280
                    )
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.showForm
                ? _c("api-client-form", {
                    attrs: {
                      "is-visible": _vm.showForm,
                      staffs: _vm.availableStaffs,
                      scopes: _vm.scopes,
                      "scopes-tree": _vm.scopesTree,
                      "edited-client": _vm.editedClient
                    },
                    on: {
                      "close-form": function($event) {
                        _vm.showForm = false
                      },
                      create: _vm.clientCreated,
                      update: _vm.updateClient
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.loading
        ? _c("preloader", { attrs: { background: false, display: true } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }